import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import dayjs from 'dayjs';
import 'react-quill/dist/quill.snow.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import {
  CardBody,
  Col,
  Container,
  Row,
  TabContent,
  TabPane,
  Button,
  Spinner,
  Breadcrumb,
  BreadcrumbItem,
} from 'reactstrap';
import { Link, useParams, useNavigate } from 'react-router-dom';

import RequirementTab from './RequirementTab';
import { api } from '../../config';
import { getAuthToken } from '../../auth/tokenvalidation';
import logger from '../../utils/logger';
import { registerLocale } from 'react-datepicker';
import id from 'date-fns/locale/id';
import {
  displayValue,
  formatSubmittedDate,
  getProcurementStatusConfig,
} from './utils/FreightCostHelpers';
import DataNotAvailable from '../Error/DataNotAvailable';

registerLocale('id', id);
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

const FreightCostForm = () => {
  const navigate = useNavigate();
  const token = getAuthToken();
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setactiveTab] = useState(1);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});
  const [ids] = useState(useParams().id);
  const [qtyDeliveryData, setQtyDeliveryData] = useState({ items: [] });
  const [dataCause, setDataCause] = useState({
    items: [],
  });

  const LoadDefault = () => {
    fetchDataProcurement(ids, setForm, token);
  };

  const [form, setForm] = useState({
    procurementNumber: '',
    statusProcurement: '',
    titleProcurement: '',
    description: '',
    procurementType: '',
    procurementTypeHeaderLabel: '',
    contractType: '',
    contractPeriodSpot: '',
    contractPeriodTermStart: '',
    contractPeriodTermEnd: '',
    productTypeId: '',
    productType: '',
    productName: '',
    productNameId: '',
    operationalTolerance: '',
    productSpecification: '',
    ratioLpgId: '',
    ratioLpg: '',
    refPropaneFrequency: null,
    refPropaneRangeQuantityFrom: null,
    refPropaneRangeQuantityTo: null,
    refButaneFrequency: null,
    refButaneRangeQuantityFrom: null,
    refButaneRangeQuantityTo: null,
    notesForQuantityAndDeliveryTerms: '',
    quantityDiscrepancy: '',
    delayPenaltyTerms: '',
    delivery: '',
    nominationProcedure: '',
    firstTimeSupply: '',
    redChannelPolicy: '',
    deliveryCustom: '',
    invoicingQuantityId: '',
    invoicingQuantity: '',
    modeInvoicingQuantityId: '',
    modeInvoicingQuantity: '',
    descriptionOfPaymentTerms: '',
    paymentCurrencyId: '',
    paymentCurrency: '',
    lawId: '',
    law: '',
    arbitrationId: '',
    arbitration: '',
    notesForLoadingPort: '',
    otherTermsAndCondition: '',
    additionalNotes: '',
    proposalSubmissionDeadline: '',
    proposalValidityPeriodMax: '',
    fileHasilOptimasiHilir: '',
    filePenetapanHargaDasarImpor: '',
    fileSpesifikasi: '',
    fileGeneralTermsAndConditions: '',
    fileDocumentQ88: '',
    fileDocumentGasFormC: '',
    fileSupporting1: '',
    fileSupporting2: '',
    fileSupporting3: '',
    fileSupporting4: '',
    fileSupporting5: '',
    subStatus: '',
    isInformationAboutDMUTConfirmed: '',
    isAcknowledgedDMUT: '',
    hpsRequestNumber: '',
    hpsRequestDate: '',
    userId: '',
    user: '',
    isProcurementRequirementCompleted: '',
    isSupportingDocumentsCompleted: '',
    isDMUTInvitationCompleted: '',
    isHPSRequestCompleted: '',
    id: '',
    createdBy: '',
    updatedBy: '',
    createdDate: '',
    updatedDate: '',
    isDeleted: '',
    deletedDate: '',
    deletedBy: '',
  });

  useEffect(() => {
    fetchDataProcurement(ids, setForm, token);
  }, [ids, token]);

  const fetchDataProcurement = async (ids, setForm, token) => {
    try {
      const response = await axios.get(`${api.API_URL}/procurement/${ids}`, {
        withXSRFToken: true,
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: `application/json`,
        },
      });
      const data = response;
      setForm({
        procurementNumber: data.procurementNumber || null,
        statusProcurement: data.statusProcurement || null,
        titleProcurement: data.titleProcurement || null,
        description: data.description || null,
        procurementType: data.procurementType || null,
        procurementTypeHeaderLabel: data.procurementTypeHeaderLabel || null,
        contractType: data.contractType || null,
        contractPeriodSpot: data.contractPeriodSpot || null,
        contractPeriodTermStart: data.contractPeriodTermStart || null,
        contractPeriodTermEnd: data.contractPeriodTermEnd || null,
        freightRequestNumber: data.freightRequestNumber || null,
        freightRequestDate: data.freightRequestDate || null,
        freightCostStatus: data.freightCostStatus == 0 ? false : true,
        productTypeId: data.productTypeId || null,
        productType: data.productType || null,
        productName: data.productType?.product?.name || null,
        productNameId: data.productType?.product?.id || null,
        operationalTolerance: data.operationalTolerance || null,
        productSpecification: data.productSpecification || null,
        ratioLpgId: data.ratioLpgId || null,
        ratioLpg: data.ratioLpg || null,
        refPropaneFrequency: data.refPropaneFrequency || null,
        refPropaneRangeQuantityFrom: data.refPropaneRangeQuantityFrom || null,
        refPropaneRangeQuantityTo: data.refPropaneRangeQuantityTo || null,
        refButaneFrequency: data.refButaneFrequency || null,
        refButaneRangeQuantityFrom: data.refButaneRangeQuantityFrom || null,
        refButaneRangeQuantityTo: data.refButaneRangeQuantityTo || null,
        notesForQuantityAndDeliveryTerms:
          data.notesForQuantityAndDeliveryTerms || null,
        quantityDiscrepancy: data.quantityDiscrepancy || null,
        delayPenaltyTerms: data.delayPenaltyTerms || null,
        delivery: data.delivery || null,
        nominationProcedure: data.nominationProcedure || null,
        firstTimeSupply: data.firstTimeSupply || null,
        redChannelPolicy: data.redChannelPolicy || null,
        deliveryCustom: data.deliveryCustom || null,
        invoicingQuantityId: data.invoicingQuantityId || null,
        invoicingQuantity: data.invoicingQuantity || null,
        modeInvoicingQuantityId: data.modeInvoicingQuantityId || null,
        modeInvoicingQuantity: data.modeInvoicingQuantity || null,
        descriptionOfPaymentTerms: data.descriptionOfPaymentTerms || null,
        paymentCurrencyId: data.paymentCurrencyId || null,
        paymentCurrency: data.paymentCurrency || null,
        lawId: data.lawId || null,
        law: data.law || null,
        arbitrationId: data.arbitrationId || null,
        arbitration: data.arbitration || null,
        notesForLoadingPort: data.notesForLoadingPort || null,
        otherTermsAndCondition: data.otherTermsAndCondition || null,
        additionalNotes: data.additionalNotes || null,
        proposalSubmissionDeadline: data.proposalSubmissionDeadline
          ? dayjs(data.proposalSubmissionDeadline).toDate()
          : null,
        proposalValidityPeriodMax: data.proposalValidityPeriodMax
          ? dayjs(data.proposalValidityPeriodMax).toDate()
          : null,
        fileHasilOptimasiHilir: data.fileHasilOptimasiHilir || null,
        filePenetapanHargaDasarImpor: data.filePenetapanHargaDasarImpor || null,
        fileSpesifikasi: data.fileSpesifikasi || null,
        fileGeneralTermsAndConditions:
          data.fileGeneralTermsAndConditions || null,
        fileDocumentQ88: data.fileDocumentQ88 || null,
        fileDocumentGasFormC: data.fileDocumentGasFormC || null,
        fileSupporting1: data.fileSupporting1 || null,
        fileSupporting2: data.fileSupporting2 || null,
        fileSupporting3: data.fileSupporting3 || null,
        fileSupporting4: data.fileSupporting4 || null,
        fileSupporting5: data.fileSupporting5 || null,
        subStatus: data.subStatus || null,
        isInformationAboutDMUTConfirmed:
          data.isInformationAboutDMUTConfirmed || null,
        isAcknowledgedDMUT: data.isAcknowledgedDMUT || null,
        hpsRequestNumber: data.hpsRequestNumber || null,
        hpsRequestDate: data.hpsRequestDate || null,
        userId: data.userId || null,
        user: data.user || null,
        isProcurementRequirementCompleted:
          data.isProcurementRequirementCompleted || null,
        isSupportingDocumentsCompleted:
          data.isSupportingDocumentsCompleted || null,
        isDMUTInvitationCompleted: data.isDMUTInvitationCompleted || null,
        isHPSRequestCompleted: data.isHPSRequestCompleted || null,
        isReqFreightAvailabilityCompleted:
          data.isReqFreightAvailabilityCompleted ?? null,
        id: data.id || null,
        createdBy: data.createdBy || null,
        updatedBy: data.updatedBy || null,
        createdDate: data.createdDate || null,
        updatedDate: data.updatedDate || null,
        isDeleted: data.isDeleted || null,
        deletedDate: data.deletedDate || null,
        deletedBy: data.deletedBy || null,
        noNotaDinas: data.noNotaDinas || null,
        statusHPS2: data.statusHPS2 === 1 ? true : false,
      });
      const quantityItems = (data.procurementClauseDetails || []).map(item => ({
        id: item.id ?? null,
        procurementId: item.procurementId ?? null,
        clauseDetailId: item.clauseDetailId ?? null,
        clauseTitle: item.clauseTitle ?? null,
        ordreNumber: item.ordreNumber ?? null,
        isShow: item.isShow ?? null,
        clauseDescription: item.clauseDescription ?? null,
        isShowToDMUT: item.isShowToDMUT ?? null,
      }));
      setDataCause({ items: quantityItems });
    } catch (error) {
      logger.error('Error fetching data from  API:', error);
    }
  };

  const selectedFields = {
    contractType: form.contractType,
    contractPeriodSpot: form.contractPeriodSpot,
    contractPeriodTermStart: form.contractPeriodTermStart,
    contractPeriodTermEnd: form.contractPeriodTermEnd,
    productTypeId: form.productTypeId, // <- Diperbaiki
    operationalTolerance: form.operationalTolerance,
    productSpecification: form.productSpecification,
    ratioLpgId: form.ratioLpgId,
    refPropaneFrequency: form.refPropaneFrequency,
    refPropaneRangeQuantityFrom: form.refPropaneRangeQuantityFrom,
    refPropaneRangeQuantityTo: form.refPropaneRangeQuantityTo,
    refButaneFrequency: form.refButaneFrequency,
    refButaneRangeQuantityFrom: form.refButaneRangeQuantityFrom,
    refButaneRangeQuantityTo: form.refButaneRangeQuantityTo,
    notesForQuantityAndDeliveryTerms: form.notesForQuantityAndDeliveryTerms,
    quantityDiscrepancy: form.quantityDiscrepancy,
    delayPenaltyTerms: form.delayPenaltyTerms,
    delivery: form.delivery,
    nominationProcedure: form.nominationProcedure,
    firstTimeSupply: form.firstTimeSupply,
    redChannelPolicy: form.redChannelPolicy,
    deliveryCustom: form.deliveryCustom,
    invoicingQuantityId: form.invoicingQuantityId,
    modeInvoicingQuantityId: form.modeInvoicingQuantityId,
    descriptionOfPaymentTerms: form.descriptionOfPaymentTerms,
    paymentCurrencyId: form.paymentCurrencyId,
    lawId: form.lawId,
    arbitrationId: form.arbitrationId,
    notesForLoadingPort: form.notesForLoadingPort, // <- Diperbaiki
    otherTermsAndCondition: form.otherTermsAndCondition,
    additionalNotes: form.additionalNotes,
    proposalSubmissionDeadline: form.proposalSubmissionDeadline,
    proposalValidityPeriodMax: form.proposalValidityPeriodMax,
    fileHasilOptimasiHilir: form.fileHasilOptimasiHilir,
    filePenetapanHargaDasarImpor: form.filePenetapanHargaDasarImpor,
    fileSpesifikasi: form.fileSpesifikasi,
    fileGeneralTermsAndConditions: form.fileGeneralTermsAndConditions,
    fileDocumentQ88: form.fileDocumentQ88,
    fileDocumentGasFormC: form.fileDocumentGasFormC,
    fileSupporting1: form.fileSupporting1,
    fileSupporting2: form.fileSupporting2,
    fileSupporting3: form.fileSupporting3,
    fileSupporting4: form.fileSupporting4,
    fileSupporting5: form.fileSupporting5,
    subStatus: form.subStatus,
    isInformationAboutDMUTConfirmed: form.isInformationAboutDMUTConfirmed,
    isAcknowledgedDMUT: form.isAcknowledgedDMUT,
    hpsRequestDate: form.hpsRequestDate,
    userId: form.userId,
    isProcurementRequirementCompleted: form.isProcurementRequirementCompleted,
    isSupportingDocumentsCompleted: form.isSupportingDocumentsCompleted,
    isDMUTInvitationCompleted: form.isDMUTInvitationCompleted,
    isHPSRequestCompleted: form.isHPSRequestCompleted,
  };

  const handleSaveDraftProc = async () => {
    if (validatedeliveryModal()) {
      try {
        await axios.put(`${api.API_URL}/procurement/${ids}`, selectedFields, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
      } catch (error) {
        setError(error.message);
      } finally {
        toast.success(`Data Has Been Saved `);
        LoadDefault();
      }
    }
  };

  const validatedeliveryModal = () => {
    let tempErrors = {};
    if (!form.productTypeId) {
      tempErrors.productTypeId = 'Please Select';
    }
    if (!form.productNameId) {
      tempErrors.productNameId = 'Please Select';
    }
    if (!form.contractPeriodTermStart) {
      tempErrors.contractPeriodTermStart = 'Please Enter Date';
    }
    if (!form.contractPeriodTermEnd && parseInt(form.contractType, 10) === 1) {
      tempErrors.contractPeriodTermEnd = 'Please Enter Date';
    }
    if (Object.keys(tempErrors).length !== 0) {
      toast.error('Warning ! Please Check Mandatory Fields..', {
        position: 'top-right',
        hideProgressBar: false,
        closeOnClick: false,
        className: 'bg-warning  text-black',
      });
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const fetchQtyDeliveryList = useCallback(async () => {
    if (!ids) {
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${api.API_URL}/quantity-delivery?ProcurementId=${ids}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          `HTTP error: ${response.status} ${response.statusText}`
        );
      }

      const result = await response.json();
      if (!result.data?.items) {
        logger.warn('No items found in response');
        return;
      }
      const items = result.data.items.map(item => ({
        procurementId: item.procurementId,
        ratioLpgId: item.ratioLpgId,
        ratioName: item.ratioLpg?.ratioName ?? null,
        deliveryUnit: item.deliveryUnit,
        frequency: item.frequency,

        pricingPeriod: item.pricingPeriod,
        indexPricename: item.indexPrice?.name ?? null,
        otherIndexPricename: item.otherIndexPrice?.name ?? null,
        startDatePublishIndex: item.startDatePublishIndex,
        endDatePublishIndex: item.endDatePublishIndex,
        schemaBL: item.schemaBL,
        notesForPricing: item.notesForPricing,
        isCorrelationBetweenTwoIndex: item.isCorrelationBetweenTwoIndex,
        id: item.id,
      }));
      setQtyDeliveryData({ items });
    } catch (error) {
      setIsLoading(false);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  }, [ids, token]);

  useEffect(() => {
    fetchQtyDeliveryList();
  }, [fetchQtyDeliveryList]);

  document.title = `Procurement Requirement - ${form.procurementNumber}`;
  const categoryLabel = form.procurementTypeHeaderLabel || 'Product Hydro';
  const statusConfig = getProcurementStatusConfig(form?.freightCostStatus);

  const isProcurementLoaded = Boolean(form?.id);
  const isStageReady = form?.isReqFreightAvailabilityCompleted === true;

  if (isProcurementLoaded && !isStageReady) {
    return (
      <DataNotAvailable
        title='Data Not Available'
        message={`Freight Cost can only be opened after the Request Freight Availability stage is completed.\nProcurement: ${displayValue(
          form?.procurementNumber || ids
        )}`}
        backTo='/apps-freightcost/view'
        backLabel='Back to Freight Cost List'
      />
    );
  }

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <div className='email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1 '>
            <div className='email-content minimal-border'>
              <div className='p-4 pb-0'>
                <Row className='mt-n2 mb-1 mb-sm-0'>
                  <div className='col-sm order-3 order-sm-2'>
                    <div className='hstack gap-sm-1 align-items-center flex-wrap email-topbar-link'>
                      <h5 className='card-title mb-0 flex-grow-1'>
                        <Breadcrumb listClassName='p-3 py-2 bg-light'>
                          <BreadcrumbItem>
                            <Link to='/dashboard'>Home</Link>
                          </BreadcrumbItem>
                          <BreadcrumbItem>
                            <Link to='/apps-freightcost/view'>
                              Freight Cost
                            </Link>
                          </BreadcrumbItem>
                          <BreadcrumbItem active>
                            Detail #
                            {displayValue(form?.procurementNumber || ids)}
                          </BreadcrumbItem>
                        </Breadcrumb>
                      </h5>
                    </div>
                  </div>
                </Row>
                <Row className='mb-4'>
                  <Col xs={12}>
                    <Row className='align-items-center g-3'>
                      <Col xs={12} lg>
                        <div className='d-flex align-items-start gap-3'>
                          <Button
                            color='light'
                            className='border shadow-sm rounded-circle d-flex align-items-center justify-content-center p-0'
                            style={{ width: '2.5rem', height: '2.5rem' }}
                            onClick={() => navigate('/apps-freightcost/view')}
                          >
                            <i className='bx bx-arrow-back fs-5 text-dark'></i>
                          </Button>
                          <div className='flex-grow-1'>
                            {isLoading && !form ? (
                              <div className='d-flex align-items-center gap-2 py-2'>
                                <Spinner size='sm' color='primary' />
                                <span className='text-muted small'>
                                  Loading Freight Cost...
                                </span>
                              </div>
                            ) : (
                              <>
                                <h4 className='mb-1 fw-bold text-dark'>
                                  {categoryLabel} —{' '}
                                  {displayValue(form?.titleProcurement)}
                                </h4>
                                <div className='d-flex flex-wrap align-items-center gap-2 text-muted small'>
                                  <i className='bx bx-hash'></i>
                                  <span>
                                    Procurement ID:{' '}
                                    {displayValue(form?.procurementNumber)}
                                  </span>

                                  <span className='d-none d-md-inline text-secondary opacity-25'>
                                    |
                                  </span>

                                  <i className='bx bx-calendar'></i>
                                  <span>
                                    {formatSubmittedDate(form?.createdDate)}
                                  </span>

                                  <span
                                    className={`badge ${statusConfig.className} fw-semibold px-3 py-1 rounded-pill`}
                                  >
                                    {statusConfig.label}
                                  </span>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <hr className='mt-3 mb-0 border-secondary opacity-10' />
                  </Col>
                </Row>
                <Row className='justify-content-center'>
                  <Col xxl={12}>
                    <CardBody className='checkout-tab'>
                      <TabContent activeTab={activeTab}>
                        <TabPane tabId={1} id='pills-bill-info'>
                          <RequirementTab
                            goNext={() => setactiveTab(2)}
                            ids={ids}
                            form={form}
                            setForm={setForm}
                            dataCause={dataCause}
                            handleSaveDraftProc={handleSaveDraftProc}
                            validatedeliveryModal={validatedeliveryModal}
                            errors={errors}
                            error={error}
                            setError={setError}
                            setErrors={setErrors}
                            setIsLoading={setIsLoading}
                            isLoading={isLoading}
                            qtyDeliveryData={qtyDeliveryData}
                            token={token}
                          />
                        </TabPane>
                      </TabContent>
                    </CardBody>
                  </Col>
                </Row>
                <ToastContainer closeButton={false} limit={1} />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default FreightCostForm;
